import * as types from './actionsTypes';

export const login = value => ({
  type: types.LOGIN,
  payload: value
});
